export default __webpack_public_path__ + "79ff5247dc766afcf40602e3c3b0a335.png";